// src/pages/BagsPage.jsx
import React from "react";
import './bags.css'; // make sure this CSS exists
import bagsMainImg from "../assets/bagandlugg.png"; // ✅ updated image path

export default function BagsPage() {
  return (
    <div className="bags-container">

      {/* Top Image */}
      <div className="bags-top-image">
        <img src={bagsMainImg} alt="Bags & Luggages" />
      </div>

      {/* Page Title */}
      <h1>Bags & Luggages</h1>

      {/* Description */}
      <p>
        Discover our premium collection of bags and luggages, perfect for travel, work, and everyday use. 
        From stylish backpacks, handbags, and duffle bags to durable suitcases and travel sets, we have options 
        for every occasion. All products are made from high-quality materials to ensure durability, style, and comfort. 
        Upgrade your travel essentials today and enjoy convenience with elegance.
      </p>

    </div>
  );
}